import { useContext, useRef, createContext } from 'react';
export class UniqueIdFactory {
    constructor(idGeneratorFactory) {
        this.idGenerators = {};
        this.idGeneratorFactory = idGeneratorFactory;
    }
    nextId(prefix) {
        if (!this.idGenerators[prefix]) {
            this.idGenerators[prefix] = this.idGeneratorFactory(prefix);
        }
        return this.idGenerators[prefix]();
    }
}
export function globalIdGeneratorFactory(prefix = '') {
    let index = 1;
    return () => `${prefix !== '' ? `${prefix}-` : ''}${index++}`;
}
export const UniqueIdFactoryContext = createContext(undefined);
export function useUniqueId(prefix = '', overrideId = '') {
    const idFactory = useContext(UniqueIdFactoryContext);
    const uniqueIdRef = useRef(null);
    if (!idFactory) {
        throw new Error('No UniqueIdFactory was provided.');
    }
    if (overrideId) {
        return overrideId;
    }
    if (!uniqueIdRef.current) {
        uniqueIdRef.current = idFactory.nextId(prefix);
    }
    return uniqueIdRef.current;
}
//# sourceMappingURL=unique-id.js.map